import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../hooks';
import { TP_COLORS } from '../../../../constants';
import { getAccessLimitState } from '../../../../store/AccessLimitSlice';

const UpgradeButton: React.FC = () => {
  const navigate = useNavigate();
  // Store
  const { lpAccess } = useAppSelector(getAccessLimitState);

  return (
    <Button
      disableElevation
      variant="contained"
      color="warning"
      style={{
        color: TP_COLORS.black,
        backgroundColor: TP_COLORS.yellow.light,
        marginRight: '10px',
      }}
      onClick={() => navigate(`${process.env.PUBLIC_URL}/dashboard/upgrade`)}
    >
      {lpAccess ? 'Upgraded' : 'Upgrade'}
    </Button>
  );
};

export default UpgradeButton;
